import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation, Navigate } from "react-router-dom";
import { PUBLIC_URL } from "../../app.config";
import { ImListNumbered } from "react-icons/im";
import { PiLadderSimpleFill } from "react-icons/pi";
import { MdNumbers } from "react-icons/md";
import { BsFileWord } from "react-icons/bs";
import { CiBadgeDollar } from "react-icons/ci";
import { MdLeaderboard } from "react-icons/md";
import { useMenu } from "../../context/menuContext";
import { FaUsers } from "react-icons/fa";
import { TbCircleLetterL } from "react-icons/tb";
import {
  FaMedal,
  FaTrophy,
  FaChalkboardTeacher,
  FaSchool,
  FaUserShield,
} from "react-icons/fa";
import { ImBlog } from "react-icons/im";
import Cookies from "js-cookie";
import { PermissionContext } from "../../context/PermissionContext";

const Sidebar = ({ elementRef, visible, setVisible }) => {
  const location = useLocation();
  const path = "/" + location?.pathname?.split("/")?.[1];
  let userData = Cookies.get("dataCA")
    ? JSON.parse(Cookies.get("dataCA"))
    : null;
  const role = userData ? userData.role : null;
  const { permissions } = useContext(PermissionContext);

  const hasFullAccess = (moduleId) => {
    return (
      role === "admin" ||
      permissions.some(
        (permission) =>
          permission.module_id === moduleId && permission.permission_view === 1
      )
    );
  };
  const { menuState, toggleMenu } = useMenu();

  const canManageWord = hasFullAccess(1);
  const canManageUser = hasFullAccess(2);
  const canManageTeacher = hasFullAccess(3);
  const canManageSentence = hasFullAccess(4);
  const canManageSchool = hasFullAccess(5);
  const canManageNumber = hasFullAccess(6);
  const canManageLetter = hasFullAccess(7);
  const canManageLadder = hasFullAccess(8);
  const canManageFaq = hasFullAccess(9);
  const canManageChallenge = hasFullAccess(10);
  const canManageBlog = hasFullAccess(11);
  const canManageBadge = hasFullAccess(12);
  const canManageappContent = hasFullAccess(13);
  const canManageTournament = hasFullAccess(14);

  // Check if the user is attempting to access a restricted page
  const checkPermissionAndRedirect = (canAccess, to) => {
    if (!canAccess && path === to) {
      return <Navigate to="/not_have_permission" replace />;
    }
    return null;
  };

  return (
    <>
      <Helmet>
        <script src={`${PUBLIC_URL}/assets/js/app.min.js`}></script>
      </Helmet>
      <div
        className={`leftside-menu ${
          menuState === "hide" ? "custLeftsidebar" : ""
        }`}
      >
        {/* <Link to="/" className="logo logo-light mt-5">
          <span className="logo-lg">
            <img
              src={`${PUBLIC_URL}/assets/images/logo.png`}
              alt="logo"
              style={{ height: "35px" }}
            />
          </span>
          <span className="logo-sm">
            <img
              src={`${PUBLIC_URL}/assets/images/logo.png`}
              alt="small logo"
              style={{ height: "35px" }}
            />
          </span>
        </Link> */}

        {/* <!-- Brand Logo Light --> */}
        {/* <Link to="/" className="logo logo-light">
          <span className="logo-lg">
            <img
              src={PUBLIC_URL + "/assets/images/logo.png"}
              alt="logo"
              style={{ height: "35px" }}
            />
          </span>
          <span className="logo-sm">
            <img
              src={PUBLIC_URL + "/assets/images/logo.png"}
              alt="small logo"
              style={{ height: "35px" }}
            />
          </span>
        </Link> */}

        <div className="h-100" id="leftside-menu-container">
          <ul className="side-nav">
            <li>
              {/* <!-- Brand Logo --> */}
              <Link to="/" className="logo">
                <span className="logo-lg">
                  <img
                    src={PUBLIC_URL + "/assets/images/logo.png"}
                    alt="dark logo"
                    style={{ height: "35px" }}
                  />
                </span>
                <span className="logo-sm">
                  <img
                    src={PUBLIC_URL + "/assets/images/logo.png"}
                    alt="small logo"
                    style={{ height: "35px" }}
                  />
                </span>
              </Link>
            </li>
            <li className="side-nav-title">Main</li>

            <li
              className={`side-nav-item ${path === "/" && "menuitem-active"}`}
            >
              <Link
                to="/"
                className={`side-nav-link ${path === "/" && "active"}`}
              >
                <i className="ri-dashboard-3-line"></i>
                <span> Dashboard </span>
              </Link>
            </li>

            <li
              className={`side-nav-item ${
                path === "/leaderboard" && "menuitem-active"
              }`}
            >
              <Link
                to="/leaderboard"
                className={`side-nav-link ${
                  path === "/leaderboard" && "active"
                }`}
              >
                <MdLeaderboard
                  style={{ marginLeft: "10px", marginRight: "10px" }}
                />
                <span> Leaderboard </span>
              </Link>
            </li>

            {checkPermissionAndRedirect(canManageSchool, "/manage_school")}
            {canManageSchool && (
              <li
                className={`side-nav-item ${
                  path === "/manage_school" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_school"
                  className={`side-nav-link ${
                    path === "/manage_school" && "active"
                  }`}
                >
                  <FaSchool
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage Schools </span>
                </Link>
              </li>
            )}

            {role == "admin" ? (
              <li
                className={`side-nav-item ${
                  path === "/manage_subadmin" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_subadmin"
                  className={`side-nav-link ${
                    path === "/manage_subadmin" && "active"
                  }`}
                >
                  <FaUserShield
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage Sub Admin</span>
                </Link>
              </li>
            ) : null}

            {role == "admin" && (
              <li
                className={`side-nav-item ${
                  path === "/manage_subscription" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_subscription"
                  className={`side-nav-link ${
                    path === "/manage_subscription" && "active"
                  }`}
                >
                  <i className="bi bi-bell" />
                  <span>Manage Subscription</span>
                </Link>
              </li>
            )}

            {checkPermissionAndRedirect(canManageTeacher, "/manage_teacher")}
            {canManageTeacher && (
              <li
                className={`side-nav-item ${
                  path === "/manage_teacher" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_teacher"
                  className={`side-nav-link ${
                    path === "/manage_teacher" && "active"
                  }`}
                >
                  <FaChalkboardTeacher
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage Teacher </span>
                </Link>
              </li>
            )}

            {checkPermissionAndRedirect(canManageUser, "/manage_client")}
            {canManageUser && (
              <li
                className={`side-nav-item ${
                  path === "/manage_client" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_client"
                  className={`side-nav-link ${
                    path === "/manage_client" && "active"
                  }`}
                >
                  <FaUsers
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage User </span>
                </Link>
              </li>
            )}

            {checkPermissionAndRedirect(canManageLetter, "/manage_latter")}
            {canManageLetter && (
              <li
                className={`side-nav-item ${
                  path === "/manage_latter" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_latter"
                  className={`side-nav-link ${
                    path === "/manage_latter" && "active"
                  }`}
                >
                  <TbCircleLetterL
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage Letter </span>
                </Link>
              </li>
            )}

            {checkPermissionAndRedirect(canManageNumber, "/manage_number")}
            {canManageNumber && (
              <li
                className={`side-nav-item ${
                  path === "/manage_number" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_number"
                  className={`side-nav-link ${
                    path === "/manage_number" && "active"
                  }`}
                >
                  <ImListNumbered
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage Number </span>
                </Link>
              </li>
            )}

            {checkPermissionAndRedirect(canManageWord, "/manage_word")}
            {canManageWord && (
              <li
                className={`side-nav-item ${
                  path === "/manage_word" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_word"
                  className={`side-nav-link ${
                    path === "/manage_word" && "active"
                  }`}
                >
                  <BsFileWord
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage Word </span>
                </Link>
              </li>
            )}
            {checkPermissionAndRedirect(canManageSentence, "/manage_sentence")}
            {canManageSentence && (
              <li
                className={`side-nav-item ${
                  path === "/manage_sentence" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_sentence"
                  className={`side-nav-link ${
                    path === "/manage_sentence" && "active"
                  }`}
                >
                  <MdNumbers
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage Sentence </span>
                </Link>
              </li>
            )}

            {checkPermissionAndRedirect(
              canManageLadder,
              "/manage_ladder_letter"
            )}
            {canManageLadder && (
              <li
                className={`side-nav-item ${
                  path === "/manage_ladder_letter" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_ladder_letter"
                  className={`side-nav-link ${
                    path === "/manage_ladder_letter" && "active"
                  }`}
                >
                  <PiLadderSimpleFill
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage Ladder Letter </span>
                </Link>
              </li>
            )}

            {checkPermissionAndRedirect(
              canManageTournament,
              "/manage_tournament"
            )}
            {canManageTournament && (
              <li
                className={`side-nav-item ${
                  path === "/manage_tournament" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_tournament"
                  className={`side-nav-link ${
                    path === "/manage_tournament" && "active"
                  }`}
                >
                  <FaMedal
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage Tournament </span>
                </Link>
              </li>
            )}

            {checkPermissionAndRedirect(
              canManageChallenge,
              "/manage_challenge"
            )}
            {canManageChallenge && (
              <li
                className={`side-nav-item ${
                  path === "/manage_challenge" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_challenge"
                  className={`side-nav-link ${
                    path === "/manage_challenge" && "active"
                  }`}
                >
                  <FaTrophy
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage Challenges </span>
                </Link>
              </li>
            )}

            {checkPermissionAndRedirect(canManageBadge, "/manage_badge")}
            {canManageBadge && (
              <li
                className={`side-nav-item ${
                  path === "/manage_badge" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_badge"
                  className={`side-nav-link ${
                    path === "/manage_badge" && "active"
                  }`}
                >
                  <CiBadgeDollar
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  />
                  <span> Manage Badge </span>
                </Link>
              </li>
            )}

            {checkPermissionAndRedirect(canManageBlog, "/manage_blog")}
            {canManageBlog && (
              <li
                className={`side-nav-item ${
                  path === "/manage_blog" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_blog"
                  className={`side-nav-link ${
                    path === "/manage_blog" && "active"
                  }`}
                >
                  <ImBlog style={{ marginLeft: "10px", marginRight: "10px" }} />
                  <span> Manage Blog </span>
                </Link>
              </li>
            )}

            <li className="side-nav-title">Others</li>

            <li
              className={`side-nav-item ${
                path === "/manage_contact" && "menuitem-active"
              }`}
            >
              <Link
                to="/manage_contact"
                className={`side-nav-link ${
                  path === "/manage_contact" && "active"
                }`}
              >
                <i className="ri-phone-line"></i>
                <span> Manage Contact</span>
              </Link>
            </li>

            {role === "admin" ? (
              <li
                className={`side-nav-item ${
                  path === "/manage_notification" && "menuitem-active"
                }`}
              >
                <Link
                  to="/manage_notification"
                  className={`side-nav-link ${
                    path === "/manage_notification" && "active"
                  }`}
                >
                  <i className="ri-notification-2-line"></i>
                  <span> Manage Notification</span>
                </Link>
              </li>
            ) : null}
            {role === "admin" ? (
              <>
                <li
                  className={`side-nav-item ${
                    (path === "/about_us" ||
                      path === "/privacy_policy" ||
                      path === "/terms_and_condition") &&
                    "menuitem-active"
                  }`}
                >
                  <a
                    data-bs-toggle="collapse"
                    href="#sidebarIcons"
                    aria-expanded="false"
                    aria-controls="sidebarIcons"
                    className={`side-nav-link ${
                      (path === "/about_us" ||
                        path === "/privacy_policy" ||
                        path === "/terms_and_condition") &&
                      "active"
                    }`}
                  >
                    <i className="ri-pages-line"></i>
                    <span>App Content</span>
                    <span className="menu-arrow"></span>
                  </a>
                  <div className="collapse" id="sidebarIcons">
                    <ul className="side-nav-second-level">
                      <li
                        className={`side-nav-item ${
                          path === "/about_us" && "menuitem-active"
                        }`}
                      >
                        <Link
                          to="/about_us"
                          className={`side-nav-link ${
                            path === "/about_us" && "active"
                          }`}
                        >
                          About Us
                        </Link>
                      </li>
                      <li
                        className={`side-nav-item ${
                          path === "/privacy_policy" && "menuitem-active"
                        }`}
                      >
                        <Link
                          to="/privacy_policy"
                          className={`side-nav-link ${
                            path === "/privacy_policy" && "active"
                          }`}
                        >
                          Privacy Policy
                        </Link>
                      </li>
                      <li
                        className={`side-nav-item ${
                          path === "/terms_and_condition" && "menuitem-active"
                        }`}
                      >
                        <Link
                          to="/terms_and_condition"
                          className={`side-nav-link ${
                            path === "/terms_and_condition" && "active"
                          }`}
                        >
                          Terms & Condition
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <li
                  className={`side-nav-item ${
                    path === "/manage_faq" && "menuitem-active"
                  }`}
                >
                  <Link
                    to="/manage_faq"
                    className={`side-nav-link ${
                      path === "/manage_faq" && "active"
                    }`}
                  >
                    <i className="ri-question-answer-line"></i>
                    <span>Manage FAQ's</span>
                  </Link>
                </li>
              </>
            ) : null}

            <li
              className={`side-nav-item ${
                path === "/change_password" && "menuitem-active"
              }`}
            >
              <Link
                to="/change_password"
                className={`side-nav-link ${
                  path === "/change_password" && "active"
                }`}
              >
                <i className="ri-settings-3-line"></i>
                <span> Change Password</span>
              </Link>
            </li>

            {role === "admin" && (
              <li
                className={`side-nav-item ${
                  path === "/setting" && "menuitem-active"
                }`}
              >
                <Link
                  to="/setting"
                  className={`side-nav-link ${path === "/setting" && "active"}`}
                >
                  <i className="ri-settings-3-line"></i>
                  <span> Setting</span>
                </Link>
              </li>
            )}
          </ul>

          <div className="clearfix"></div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
